import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { LightningId } from 'owa-lightning-v2';
import { getUpsellStrings } from '../utils/getUpsellStrings';
import { UpsellBanner, UpsellBannerContent } from './UpsellBanner';

function always(lightup: () => void) {
    lightup();
}

export interface EdgeUpsellBannerProps {
    lid: string;
}

const emptyUpsellString: UpsellBannerContent = {
    contentId: '',
    contentMessage: '',
    contentLinkHref: '',
    contentLinkButtonText: '',
};

export const EdgeUpsellBanner = observer(function EdgeUpsellBanner(props: EdgeUpsellBannerProps) {
    const upsellContentToShow: UpsellBannerContent = React.useMemo(() => {
        if (props.lid == LightningId.EdgeUpsell) {
            let upsellStrings = getUpsellStrings();
            return upsellStrings[Math.floor(Math.random() * upsellStrings.length)];
        }
        return emptyUpsellString;
    }, []);

    return (
        <UpsellBanner
            lid={props.lid}
            when={always}
            upsellName={'EdgeUpsell'}
            upsellContentToShow={upsellContentToShow}
        />
    );
});
